import type { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import type { BaseApiCallOptions } from '@/api/httpHelper';
import { useUserStore } from '@/stores';

export default (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (res: AxiosResponse) => {
      return res;
    },
    async (err: AxiosError) => {
      if (err?.response?.status === 401) {
        const userStore = useUserStore();
        await userStore.logout(window.location.pathname);
        return Promise.reject(err);
      }
      const config = err?.response?.config as BaseApiCallOptions;
      if (
        String(err?.response?.status).startsWith('4')
      ) {
        if (config?.retryCount) {
          config.retryCount -= 1;
          const delayRetryRequest = new Promise<void>((resolve) => {
            setTimeout(() => {
              resolve();
            }, config?.retryDelay || 200);
          });
          return delayRetryRequest.then(() => axiosInstance(config));
        }
      }
      return Promise.reject(err);
    },
  );
};